/* Home box slider: fan effect from the template, caption follows the active box */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.products_img_slider_component');
  if (!root || typeof Swiper === 'undefined') return;
  var slides = Array.prototype.slice.call(root.querySelectorAll('.swiper-slide.is-product-img'));
  var boxes = slides.map(function (s) { return s.dataset; });
  var cap = document.querySelector('.pb_caption');

  // The centred card is the link to its product. The overlay sits inside the
  // panel rather than wrapping it: the fan effect transforms
  // .swiper-slide > *, so an extra wrapper would break that selector. Added
  // before Swiper initialises so the loop clones carry it too.
  slides.forEach(function (s) {
    var panel = s.querySelector('.pb_panel');
    if (!panel || !s.dataset.href || panel.querySelector('.pb_link')) return;
    var a = document.createElement('a');
    a.className = 'pb_link';
    a.href = s.dataset.href;
    a.tabIndex = -1;
    a.setAttribute('aria-label', s.dataset.name || '');
    panel.appendChild(a);
  });
  function show(i) {
    var b = boxes[i]; if (!b || !cap) return;
    // the name is printed on the card itself, so the caption is the tagline
    cap.querySelector('.pb_caption_desc').textContent = b.desc || '';
  }
  // Only the centred card's link is reachable: the fanned cards beside it are
  // decoration, and the loop clones would otherwise put a second copy of every
  // link in the tab order.
  function linkable() {
    // a looped Swiper marks the clone of the centred slide active as well, so
    // only the first one gets the tab stop
    var taken = false;
    Array.prototype.forEach.call(root.querySelectorAll('.swiper-slide.is-product-img'), function (s) {
      var a = s.querySelector('.pb_link');
      if (!a) return;
      var first = s.classList.contains('is-active') && !taken;
      if (first) taken = true;
      a.setAttribute('tabindex', first ? '0' : '-1');
    });
  }
  var sw = new Swiper(root.querySelector('.swiper'), {
    speed: 600, loop: true, loopAdditionalSlides: 4, centeredSlides: true, slidesPerView: 1, spaceBetween: 30,
    grabCursor: true, keyboard: { enabled: true, onlyInViewport: true }, mousewheel: { forceToAxis: true },
    navigation: { nextEl: root.querySelector('.common-swiper-next'), prevEl: root.querySelector('.common-swiper-prev') },
    slideActiveClass: 'is-active', slideDuplicateActiveClass: 'is-active',
    on: {
      init: function (s) { show(s.realIndex); linkable(); },
      slideChange: function (s) { show(s.realIndex); linkable(); },
      transitionEnd: linkable
    }
  });
});
